import { FullPost } from 'model';
import { BasicView } from './BasicView.js';
import { BusinessCheckInView } from './BusinessCheckInView.js';
import { BusinessPostView } from './BusinessPostView.js';
import { CommunityQuestionView } from './CommunityQuestionView.js';
import { EventView } from './EventView.js';
import { MarketplaceItemView } from './MarketplaceItemView.js';
import { PollView } from './PollView.js';
import { PostTypeViewProps } from './types';

/**
 * PostTypeView component - Renders the correct post type view based on postType
 * @param { PostTypeViewProps<FullPost> } - post to render
 * @returns { JSX.Element } - the rendered post
 */
export function PostTypeView({ post, preview, ...rest }: PostTypeViewProps<FullPost>): JSX.Element {
	const testId = `PostContent-${post._id}`;

	switch (post.postType) {
		case 'basic':
			return <BasicView preview={preview} post={post} {...rest} testId={testId} />;
		case 'poll':
			return <PollView preview={preview} post={post} {...rest} testId={testId} />;
		case 'communityQuestion':
			return <CommunityQuestionView preview={preview} post={post} {...rest} testId={testId} />;
		case 'event':
			return <EventView preview={preview} post={post} {...rest} testId={testId} />;
		case 'businessPost':
			return <BusinessPostView preview={preview} post={post} {...rest} testId={testId} />;
		case 'businessCheckIn':
			return <BusinessCheckInView preview={preview} post={post} {...rest} testId={testId} />;
		case 'marketplaceItem':
			return <MarketplaceItemView preview={preview} post={post} {...rest} testId={testId} />;
		default:
			return <BasicView preview={preview} post={post} {...rest} testId={testId} />;
	}
}
